<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">

    <div class="layout-sidebar-top">
        <div class="layout-sidebar-logo">
            <h4>eFAACT Central</h4>
        </div>
        <!-- <img style="width: 150px; height: 55px;" class="layout-sidebar-logo" [src]="'../../../images/efaacttransparent_white-' + (layoutService.isDarkTheme() ? 'avalon-dark' : 'avalon') + '.png'" alt="eF" /> -->
        <img style="width: 40px; height: 40px;" class="layout-sidebar-logo-slim" [src]="'../../../images/eflogotransparent-avalon-dark' + '.png'" alt="eF" />
        <button class="layout-sidebar-anchor" type="button" (click)="anchor()"></button>
    </div>

    <div #lmc class="layout-menu-container">
        <!-- <div class="mt-2" app-menu-profile [roles]="roles" [userInfo]="userInfo" *ngIf="menuProfilePosition === 'start'"></div> -->
        <div app-menu [roleDrivenModel]="roleDrivenModel"></div>
    </div>

</div>
